<h1 class="ap-blue">{{'ml_144137' | translate}}</h1>

@if(!(commonDataLoading$ | async)) {
<app-smart-search-form [defaultSearchCriteria$]="defaultSearchCriteria$" [formPath]="formPath" [searchByList]="kpiConfigurationSearchByList$ | async" [onSearch]="onSearch" [searching$]="searching$"
  [noMoreFilter]="true"></app-smart-search-form>
}

@if(!(commonDataLoading$ | async) && isEditable$ | async) {
<div class="row ms-0 mb-2">
  <div class="col p-0">
    <button (click)="onEdit()" [disabled]="selectedItems.length !== 1" class="button--default me-3">{{ 'ml_143925' | translate }}</button>
  </div>
</div>
}

<app-message-data [errorMsg$]="errorMessage$"></app-message-data>

<app-data-grid [isLoading]="(searching$ | async) || (commonDataLoading$ | async)" [dataSource$]="dataSource$" [columnsDef]="dataGridColumnDef" [enableRowSelect]="true" [multiSelect]="false"
  (rowSelected)="rowSelected($event)" [enablePagination]="false" [defaultPageFilterSetting]="pageFilterSetting">
</app-data-grid>
